module.exports = __webpack_public_path__ + "static/welfare.ec5b36f6.png";